import { ReactNode } from 'react';
import { Align, Justify, SpaceVariant } from '../Common/types';
import { StyledBox } from '../Common/StyledBox';
import {
  AccessibilityProps,
  resolveResponsiveProp,
  ResponsiveProp,
  spaceVariantToValue,
} from '../Common/boxUtils';

export type StackProps = {
  children?: ReactNode;
  justify?: ResponsiveProp<Justify>;
  align?: ResponsiveProp<Align>;
  gap?: ResponsiveProp<SpaceVariant>;
  flex?: number;
  as?: 'div' | 'span' | 'ol' | 'ul' | 'section' | 'main';
} & AccessibilityProps;

export const Stack = ({
  children,
  justify = 'flex-start', // default value
  align = 'stretch', // default value
  gap = 'none', // default value
  flex,
  ...rest
}: StackProps) => {
  const resolvedGap = spaceVariantToValue(gap);

  return (
    <StyledBox
      $display={'flex'}
      $flexDirection={'column'}
      $justify={resolveResponsiveProp<Justify, Justify>(justify)}
      $align={resolveResponsiveProp<Align, Align>(align)}
      $gap={resolvedGap}
      $flex={resolveResponsiveProp(flex?.toString())}
      {...rest}
    >
      {children}
    </StyledBox>
  );
};
